module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/DrainTheOceans_NetEffects.60add6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/DrainTheOceans_NetEffects.jpg
// module id = zYvZ
// module chunks = 0